<template>
    <div class="sales-card-promo">
        <div class="card-promo-carousel">
            <swiper :options="swiperOption" ref="CardPromoCarousel" v-if="!isMobileChecker">
                <swiper-slide v-for="(slide, index) in salesCardArr.project_page_in.main_gallery" :key="index">
                    <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                </swiper-slide>
            </swiper>
            <swiper :options="swiperOption" ref="CardPromoCarousel" v-if="isMobileChecker">
                <swiper-slide v-for="(slide, index) in salesCardArr.project_page_in.main_gallery_mobile" :key="index">
                    <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                </swiper-slide>
            </swiper>
            <div class="carousel-info">
                <h1>{{ salesCardArr.project_name.name }}</h1>
                <p v-html="salesCardArr.project_page_in.main_desc"></p>
            </div>
            <div class="swiper-controls sales-card-promo-controls">
                <div class="sales-card-promo-btn-prev slider-btn btn-wow-effect-hover">
                    <svgIcon name="arrow-left" class="icon-left-arrow"/>
                </div>
                <div class="sales-card-promo-btn-next slider-btn btn-wow-effect-hover">
                    <svgIcon name="arrow-right" class="icon-right-arrow"/>
                </div>
            </div>
            <div class="swiper-pagination sales-card-promo-pagination"></div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'sales-card-nav',
        props: ['salesCardArr'],
        components: {
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                swiperOption: {
                    speed: 1000,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    slidesPerView: 1,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    loop: true,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.sales-card-promo-btn-next',
                        prevEl: '.sales-card-promo-btn-prev',
                    },
                    pagination: {
                        el: '.sales-card-promo-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                },
            }
        },
        computed: mapGetters({
            isMobileChecker: 'loadIsMobileChecker',
            // indexPage: 'loadIndexPage',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales-card/sales-card-promo.scss';
    @import '@/styles/components/sales-card/respond/sales-card-promo-respond.scss';
    // @import '@/styles/components/home-page/respond/home-actions-respond.scss';
    // @import '@/styles/components/home-page/respond/home-promo-respond.scss';
</style>